export const DatasetActionTypes = {
  SET_DATASET_CATEGORIES: "SET_DATASET_CATEGORIES",
  UPDATE_DATASET_CHECKED: "UPDATE_DATASET_CHECKED",
  SET_DATASET_SOURCES: "SET_DATASET_SOURCES",
};
